<template>
    <v-layout column child-flex text-center pa-0 class="pfo-mato-perfdet-1">

      <v-flex d-flex hidden-xs-only xs6>
        <v-container class="container2" @click="loadUrlPerfumeOnSite(item)">
          <v-tooltip v-if="false" top color="green">
            <template v-slot:activator="{ on: ontooltip }">
            <v-layout column justify-center class="pfo-perfdet-std">

            <div style="position: relative;">
              <v-img v-on="ontooltip"
                      :src="item.thumb_image_url"
                      contain
                      height="180px"
                      style="margin-top: 10px"
              ></v-img>
            </div>

            <div v-on="ontooltip">
                <v-flex xs12 class="font-weight-bold body-1 perfumeTitle text-center">{{item.name}}</v-flex>
                <v-flex xs12 class="font-weight-light body-1  perfumeBrand text-center">{{item.brand.name}}</v-flex>
                <div id="matopfofavorite-1" style="display: none">{{item.name}} / {{item.brand.name}}</div>
            </div>

            <div>
            <v-flex d-flex v-on="ontooltip">
                <v-flex xs5>
                  <v-icon color="#CCCCCC" v-if="item.gender==='women'" large>female</v-icon>
                  <v-icon color="#CCCCCC" v-else-if="item.gender==='men'" large>male</v-icon>
                  <v-icon color="#CCCCCC" v-else large>male female</v-icon>
                </v-flex>
                <v-flex xs7 v-if="item.product_type==='edp'"  class="font-weight-light body-1 text-center">EDP</v-flex>
                <v-flex xs7 v-else-if="item.product_type==='edt'"  class="font-weight-light body-1 text-center">EDT</v-flex>
                <v-flex xs7 v-else-if="item.product_type==='edc'" class="font-weight-light body-1 text-center">EDC</v-flex>
                <v-flex xs7 v-else-if="item.product_type==='eau_fraiche'" class="font-weight-light body-1 text-center">EF</v-flex>
                <v-flex xs7 v-else class="font-weight-light body-1 text-center">Parfum</v-flex>
            </v-flex>
            </div>

            <div>
              <v-flex v-if="in_retailer" d-flex mv-3 v-on="ontooltip">
                <v-flex ><v-icon class="verifIcon" color="green">verified</v-icon></v-flex>
                <v-flex xs10 class="font-weight-regular body-1 text-center pt-1 blue--text" v-html="availableInThisShop"></v-flex>
              </v-flex>
            </div>
            </v-layout>
            </template>
            <span>{{goToProductPage}}</span>
          </v-tooltip>

          <v-layout v-else column fill-height justify-center class="pfo-perfdet-std" style="position: relative;">

              <v-img
                     :src="item.thumb_image_url"
                     contain
                     xs6
                     height="180px"
                     style="margin-top: 20px !important"
              ></v-img>
              <v-img v-if="item.discontinued" style="position: absolute; top: 50px; opacity: 0.8;" :src="getBanLogo()" contain xs6 height="130px"></v-img>
            <div>
              <v-flex isAvail v-if="in_retailer" d-flex mv-3 v-on="ontooltip">
                <v-flex ><v-icon class="verifIcon" color="green">verified</v-icon></v-flex>
                <v-flex xs10 class="font-weight-regular body-1 text-center pt-1" v-html="availableInThisShop"></v-flex>
              </v-flex>
            </div>

            <div>
              <v-flex xs12 class="font-weight-light body-1 perfumeBrand text-center">{{item.brand.name}}</v-flex>
              <v-flex xs12 class="font-weight-regular body-1 perfumeTitle text-center">{{item.name}}</v-flex>
              <div id="matopfofavorite-1" style="display: none">{{item.name}} / {{item.brand.name}}</div>
            </div>

            <div>
              <v-flex d-flex sexe >
                <v-flex sexeBorder>
                  <v-icon color="#CCCCCC" v-if="item.gender==='women'" medium>female</v-icon>
                  <v-icon color="#CCCCCC" v-else-if="item.gender==='men'" medium>male</v-icon>
                  <v-icon color="#CCCCCC" v-else medium>malefemale</v-icon>
                </v-flex>
                <v-flex typeBorder xs12 v-if="item.product_type==='edp'"  class="font-weight-light body-1 text-center">Eau de parfum</v-flex>
                <v-flex typeBorder xs12 v-else-if="item.product_type==='edt'"  class="font-weight-light body-1 text-center">Eau de toilette</v-flex>
                <v-flex typeBorder xs12 v-else-if="item.product_type==='edc'" class="font-weight-light body-1 text-center">Eau de cologne</v-flex>
                <v-flex typeBorder xs12 v-else-if="item.product_type==='eau_fraiche'" class="font-weight-light body-1 text-center">Eau fraiche</v-flex>
                <v-flex typeBorder xs12 v-else class="font-weight-light body-1 text-center">Parfum</v-flex>
                <v-flex typeBorder v-if="item.year" xs4 class="font-weight-light body-1 text-center">{{item.year}}</v-flex>
              </v-flex>
            </div>

          </v-layout>

        </v-container>
      </v-flex>
      <v-flex d-flex hidden-xs-only xs6>
        <NotesList
                :item="item"
                :locale="locale"
                :country="country"
                :isMobile="isMobile"
        />
      </v-flex>
    </v-layout>
</template>
<script>
  import NotesList from "./NotesList"
  import toolsMixin from "../mixin/toolsMixin"

  export default {
    name: 'PerfumeDetails',
    components: {NotesList},
    mixins: [toolsMixin],

    data() {
      return {
        isLoading:false,
        currentUrl: null,
        item: {
          name: null,
          brand: {
            name: null
          }

        },
        top_notes:[],
        activeColor: '#AAA',
        hvalue:{},
        displayDetails:true,
        localeOver: null,
        in_retailer: false
      }
    },
    props: {
      perfFav: {},
      perfDetails: {},
      mode: {},
      isFavorite: {
        type: Boolean,
        default: () => false
      },
      perfFromUrl: {
        type: Boolean,
        default: () => false
      },
      locale: {
        type: String,
        default: () => 'en'
      },
      country: {
        type: String,
        default: () => 'UK'
      },
      isMobile: {
        type: Boolean,
        default: () => false
      }
    },
    computed: {
      yourperf() {
        if (this.locale==="en") return process.env.VUE_APP_YOUR_PERFUME_EN
        if (this.locale==="fr") return process.env.VUE_APP_YOUR_PERFUME_FR
        if (this.locale==="es") return process.env.VUE_APP_YOUR_PERFUME_ES
        if (this.locale==="de") return process.env.VUE_APP_YOUR_PERFUME_DE
        if (this.locale==="ja") return process.env.VUE_APP_YOUR_PERFUME_JP
        if (this.locale==="ar") return process.env.VUE_APP_YOUR_PERFUME_AR
        if (this.locale==="pt") return process.env.VUE_APP_YOUR_PERFUME_PT
        if (this.locale==="sv") return process.env.VUE_APP_YOUR_PERFUME_SV
        if (this.locale==="ru") return process.env.VUE_APP_YOUR_PERFUME_RU
        if (this.locale==="tr") return process.env.VUE_APP_YOUR_PERFUME_TR
        if (this.locale==="ms") return process.env.VUE_APP_YOUR_PERFUME_MS
        if (this.locale==="it") return process.env.VUE_APP_YOUR_PERFUME_IT
        if (this.locale==="ko") return process.env.VUE_APP_YOUR_PERFUME_KO
        if (this.locale==="nl") return process.env.VUE_APP_YOUR_PERFUME_NL
        return process.env.VUE_APP_YOUR_PERFUME_EN
      },
      redColor () {
        return process.env.VUE_APP_COLOR
      },
      year() {
        if (this.locale==="en") return process.env.VUE_APP_YEAR_EN
        if (this.locale==="fr") return process.env.VUE_APP_YEAR_FR
        if (this.locale==="es") return process.env.VUE_APP_YEAR_ES
        if (this.locale==="de") return process.env.VUE_APP_YEAR_DE
        if (this.locale==="ja") return process.env.VUE_APP_YEAR_JP
        if (this.locale==="ar") return process.env.VUE_APP_YEAR_AR
        if (this.locale==="pt") return process.env.VUE_APP_YEAR_PT
        if (this.locale==="sv") return process.env.VUE_APP_YEAR_SV
        if (this.locale==="ru") return process.env.VUE_APP_YEAR_RU
        if (this.locale==="tr") return process.env.VUE_APP_YEAR_TR
        if (this.locale==="ms") return process.env.VUE_APP_YEAR_MS
        if (this.locale==="it") return process.env.VUE_APP_YEAR_IT
        if (this.locale==="ko") return process.env.VUE_APP_YEAR_KO
        if (this.locale==="nl") return process.env.VUE_APP_YEAR_NL
        return process.env.VUE_APP_YEAR_EN
      },
      saf() {
        if (this.locale==="en") return process.env.VUE_APP_SELECT_AS_FAV_EN
        if (this.locale==="fr") return process.env.VUE_APP_SELECT_AS_FAV_FR
        if (this.locale==="es") return process.env.VUE_APP_SELECT_AS_FAV_ES
        if (this.locale==="de") return process.env.VUE_APP_SELECT_AS_FAV_DE
        if (this.locale==="ja") return process.env.VUE_APP_SELECT_AS_FAV_JP
        if (this.locale==="ar") return process.env.VUE_APP_SELECT_AS_FAV_AR
        if (this.locale==="pt") return process.env.VUE_APP_SELECT_AS_FAV_PT
        if (this.locale==="sv") return process.env.VUE_APP_SELECT_AS_FAV_SV
        if (this.locale==="ru") return process.env.VUE_APP_SELECT_AS_FAV_RU
        if (this.locale==="tr") return process.env.VUE_APP_SELECT_AS_FAV_TR
        if (this.locale==="ms") return process.env.VUE_APP_SELECT_AS_FAV_MS
        if (this.locale==="it") return process.env.VUE_APP_SELECT_AS_FAV_IT
        if (this.locale==="ko") return process.env.VUE_APP_SELECT_AS_FAV_KO
        if (this.locale==="nl") return process.env.VUE_APP_SELECT_AS_FAV_NL
        return process.env.VUE_APP_SELECT_AS_FAV_EN
      },
      availableInThisShop() {
        if (this.locale==="en") return process.env.VUE_APP_AVAILABLE_IN_THIS_SHOP_EN
        if (this.locale==="fr") return process.env.VUE_APP_AVAILABLE_IN_THIS_SHOP_FR
        if (this.locale==="es") return process.env.VUE_APP_AVAILABLE_IN_THIS_SHOP_EN
        if (this.locale==="de") return process.env.VUE_APP_AVAILABLE_IN_THIS_SHOP_DE
        if (this.locale==="ja") return process.env.VUE_APP_AVAILABLE_IN_THIS_SHOP_JP
        if (this.locale==="ar") return process.env.VUE_APP_AVAILABLE_IN_THIS_SHOP_EN
        if (this.locale==="pt") return process.env.VUE_APP_AVAILABLE_IN_THIS_SHOP_EN
        if (this.locale==="sv") return process.env.VUE_APP_AVAILABLE_IN_THIS_SHOP_SV
        if (this.locale==="ru") return process.env.VUE_APP_AVAILABLE_IN_THIS_SHOP_RU
        if (this.locale==="tr") return process.env.VUE_APP_AVAILABLE_IN_THIS_SHOP_TR
        if (this.locale==="ms") return process.env.VUE_APP_AVAILABLE_IN_THIS_SHOP_MS
        if (this.locale==="it") return process.env.VUE_APP_AVAILABLE_IN_THIS_SHOP_IT
        if (this.locale==="ko") return process.env.VUE_APP_AVAILABLE_IN_THIS_SHOP_KO
        if (this.locale==="nl") return process.env.VUE_APP_AVAILABLE_IN_THIS_SHOP_NL
        return process.env.VUE_APP_AVAILABLE_IN_THIS_SHOP_EN
      },
      goToProductPage() {
        if (this.locale==="en") return process.env.VUE_APP_GO_TO_PRODUCT_PAGE_EN
        if (this.locale==="fr") return process.env.VUE_APP_GO_TO_PRODUCT_PAGE_FR
        if (this.locale==="es") return process.env.VUE_APP_GO_TO_PRODUCT_PAGE_EN
        if (this.locale==="de") return process.env.VUE_APP_GO_TO_PRODUCT_PAGE_DE
        if (this.locale==="ja") return process.env.VUE_APP_GO_TO_PRODUCT_PAGE_JP
        if (this.locale==="ar") return process.env.VUE_APP_GO_TO_PRODUCT_PAGE_EN
        if (this.locale==="pt") return process.env.VUE_APP_GO_TO_PRODUCT_PAGE_EN
        if (this.locale==="sv") return process.env.VUE_APP_GO_TO_PRODUCT_PAGE_SV
        if (this.locale==="ru") return process.env.VUE_APP_GO_TO_PRODUCT_PAGE_RU
        if (this.locale==="tr") return process.env.VUE_APP_GO_TO_PRODUCT_PAGE_TR
        if (this.locale==="ms") return process.env.VUE_APP_GO_TO_PRODUCT_PAGE_MS
        if (this.locale==="it") return process.env.VUE_APP_GO_TO_PRODUCT_PAGE_IT
        if (this.locale==="ko") return process.env.VUE_APP_GO_TO_PRODUCT_PAGE_KO
        if (this.locale==="nl") return process.env.VUE_APP_GO_TO_PRODUCT_PAGE_NL
        return process.env.VUE_APP_GO_TO_PRODUCT_PAGE_EN
      }
    },
    watch: {
      perfDetails(perf) {
        this.callPerfume(perf)
        this.checkFavorite(perf)
        if (this.mode==="web") {
          this.hvalue="200px"
          this.displayDetails=true
        }
        else {
          this.hvalue = "140px"
          this.displayDetails = false
        }
      },
      perfFav(perf) {
        this.checkFavorite(perf)
      }
    },
    created () {
      if (process.env.VUE_APP_PFOKEY) {
        this.pfokey = process.env.VUE_APP_PFOKEY
      }
      if (process.env.VUE_APP_CUSTOMERKEY) {
        this.customerkey = process.env.VUE_APP_CUSTOMERKEY
      }

      if (this.perfFromUrl) {
        this.callPerfume(this.perfDetails)
      }
      else {
        this.callPerfume(this.perfFav)
      }
      if (this.mode==="web") {
        this.hvalue="200px"
        this.displayDetails=true
      }
      else {
        this.hvalue="140px"
        this.displayDetails=false
      }

      if (typeof window._paq !== 'undefined') {window._paq.push(['trackEvent', 'PFO Widget','Favorite', this.perfFav.name[this.locale]+' - '+this.perfFav.brand_name[this.locale]+' - id:'+this.perfFav.id])}
      let pname = ''
      let bname = ''

      if (typeof this.perfFav.brand_name !== 'undefined') {
        if (typeof this.perfFav.brand_name === 'object') {
          pname = this.perfFav.name.en
          bname = this.perfFav.brand_name.en
        }
        else {
          pname = this.perfFav.name[this.locale]
          bname = this.perfFav.brand_name[this.locale]
        }
      }
      else {
        pname = this.perfFav.name
        bname = this.perfFav.brand.name
      }
      let pid = this.perfFav.id
      let fpoisopen = JSON.parse(localStorage.getItem('isOpen'))
      if (typeof window._paq !== 'undefined' && fpoisopen) {window._paq.push(['trackEvent', 'PFO Widget','Favorite', pname+' - '+bname+' - id:'+pid])}
    }, // end created
    methods: {
      callPerfume: function (perf) {

        fetch(process.env.VUE_APP_API_BACKEND + '/api/products/'+perf.id+'?locale='+this.locale+'&country_code='+this.country, {
          method: 'GET',
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
            Authorization: "Business "+this.pfokey,
            Accept: "version=2"
          }
        })
          .then(
            res => res.json()
          )
          .then(res => {
            this.Message = "Fetching..."
            this.item = res.response
            console.log("HERELL: ", this.item)
            this.checkFavorite(perf, this.item)
            this.checkExistInRetailerAssortment(perf)
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => {
            this.isLoading = false
          })

      },
      getBanLogo() {
        return require(`@/assets/ban.svg`)
      },
      setFavourite: function (perfFav) {
        this.$emit('set-favourite-det', perfFav)
      },
      checkFavorite: function (perf, item) {
        if (perf.id === this.perfFav.id) {
          this.activeColor = '#CA130F'
          this.perfFav.thumb_image_url = item.normal_image_url
        } else {
          this.activeColor = '#BBB'
        }
      },
      checkExistInRetailerAssortment: function (perf) {
        fetch(process.env.VUE_APP_API_BACKEND + '/api/products/'+perf.id+'?locale='+this.locale+'&country_code='+this.country, {
          method: 'GET',
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
            Authorization: "Business "+this.customerkey,
            Accept: "version=2"
          }
        })
            .then(
                res => res.json()
            )
            .then(res => {
              this.Message = "Fetching..."
              this.item = res.response
              this.in_retailer = this.item.in_retailer

            })
            .catch(err => {
              console.log(err)
            })
            .finally(() => {
              this.isLoading = false
            })
      },
      loadUrlPerfumeOnSite: function (currentperf) {

        this.currentUrl = window.location.hostname //pathname

        console.log('loadUrlPerfumeOnSite')
        localStorage.setItem('isOpen', JSON.stringify(false))
        localStorage.setItem('closeAfterMatch', JSON.stringify(true))

        let siteperfurl = currentperf.url
        if (siteperfurl !== null && siteperfurl.length > 0) {
          localStorage.setItem('pfo_match', JSON.stringify(currentperf))
          localStorage.setItem('pfo_display_clicked_match', JSON.stringify(true))
          localStorage.setItem('close_after_match', JSON.stringify(true))
          if (process.env.VUE_APP_SITE_ID == "321") {
            let obj = {name : 'perfumist',
              url: siteperfurl
            }
            window.parent.postMessage(obj , "*")
          } else {
            window.open(siteperfurl, "_blank")
          }

        } else {
          console.log('PFO assortment url is null')
        }
        //}
      }
    },
    filters: {
      notnull: function (value) {
        return value
      },
    }
  }

</script>

<style scoped>
  .card {
    display: flex;
    flex-direction: column;
  }

  .verifIcon {
    font-size: 40px;
  }

  .isAvail {
    position: absolute;
    top: 10px;
    left: 10px;
    flex-direction: column;
    align-items: center;
  }

  .perfumeTitle {
    font-size: 22px !important;
    font-weight: bold !important;
    color: rgba(30,30,30,0.7);
  }

  .perfumeBrand {
    font-size: 14px !important;
    font-weight: semibold !important;
    color: rgba(30,30,30,0.7);
  }

  .sexeBorder {
    border: 1px rgba(30, 30, 30, 0.3) solid;
    border-radius: 10px;
    margin-right: 10px;
    font-size: 12px !important;
  }

  .typeBorder {
    border: 1px rgba(30, 30, 30, 0.3) solid;
    border-radius: 10px;
    height: 30px;
    margin-right: 10px;
    line-height: 30px;
    padding-left: 10px;
    padding-right: 10px;
    font-size: 12px !important;
    max-width: unset !important;
  }

  .sexe {
    position: absolute;
    top: 10px;
    right: 10px;
    align-items: center;
  }

  .card__media {
    flex-grow: 1
  }
  .item {
    min-height: 50px;
    min-width: 80px;
    margin: 10px;
  }
  .ingredientscontent {
    position: relative;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0%;
    width: 100%;
    height: 290px;
    overflow-y: scroll;
  }
  .orders3-layout {
    background-color: aquamarine;
    position: relative;
    width:100px;
    height: 310px;
    overflow-y: scroll;
    display: block;
    white-space: nowrap;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .detailstitlelayout {
    position: relative;
    top: 0;
    bottom: 3px;
    right: 0;
    left: 0;
    width: 100px;
    height: 70px;
  }
  .red {
    color: darkred;
  }
  .grey {
    color: grey;
  }
  .wrap2 {
    flex-wrap: wrap;
  }
  .container2 {
    margin: unset;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    padding-left: 0 !important;
    padding-right: 8px !important;
    margin-left: auto;
    margin-right: auto;
  }
  .containeroverflow {
    overflow-y: scroll;
  }
  .webheight {
    height: 100%;
  }
  .mobileheight {
    height: 180px;
  }
  .withcard {
    border-radius:5px;
  }
  .pfo-mato-perfdet-1{
    font-kerning: inherit;
    height: 100%;
    flex: 1 !important;
  }
  .pfo-perfdet-std{
    position: relative;
    cursor: pointer;
  }
  .pfo-hover{
    display: block;
    background: redColor;
  }
</style>